var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("通知總覽")])], 1)], 1)])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("通知總覽")])]), _c('div', {
    staticClass: "list-group"
  }, _vm._l(_vm.computedNotifications, function (notification) {
    return _c('div', {
      key: notification.id,
      staticClass: "list-group-item cursor-pointer",
      class: {
        'is-read': notification.is_read
      },
      on: {
        "click": function click($event) {
          return _vm.handleOpenNotificationModal(notification);
        }
      }
    }, [_c('div', {
      staticClass: "row",
      class: {
        'text-danger': notification.isImportant
      }
    }, [_c('div', {
      staticClass: "px-2",
      staticStyle: {
        "flex-basis": "40px"
      }
    }, [notification.isImportant ? _c('i', {
      staticClass: "fa fa-exclamation-triangle"
    }) : _vm._e()]), _c('div', {
      staticClass: "px-2"
    }, [_vm._v(_vm._s(notification.displayDate))]), _c('div', {
      staticClass: "px-2"
    }, [_vm._v(_vm._s(notification.title))])])]);
  }), 0)]), _c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": 10,
      "align": "center"
    },
    on: {
      "change": _vm.fetchBranchNotifications
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]), _c('NotificationModal', {
    attrs: {
      "show": _vm.isOpenNotificationModal,
      "notification": _vm.notification
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.isOpenNotificationModal = $event;
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }